import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { VarianceReportByDueDatesResult, DownloadCountsReportResult, ReportCountByStatus, SubmittedReportCountByPostAndYearResult, ReportFilter } from "../models/analytics.model";

@Injectable()
export class AnalyticsService {
  endpoint = environment.apiEndpoint + '/Analytics/';
  constructor(private http: HttpClient) {}

  getRequiredReportsCountByYear$(reportYearId: number): Observable<any> {
    return this.http.get(this.endpoint+'GetRequiredReportsCountByYear?reportYearId='+reportYearId);
  }

  getPublishedReportCountsByYear$(reportYearId: number, numberOfYears: number): Observable<any> {
    return this.http.get(this.endpoint+'GetPublishedReportCountsByYear?reportYearId='+reportYearId+'&numberOfYears='+numberOfYears);
  }

  getReportsCountByStatus$(reportYearId: number): Observable<ReportCountByStatus[]> {
    return this.http.get<ReportCountByStatus[]>(this.endpoint+'GetReportCountsByStatus?reportYearId='+reportYearId);
  }

   getReportCountsByType$(reportYearId: number): Observable<any> {
    return this.http.get(this.endpoint+'GetReportCountsByType?reportYearId='+reportYearId);
  }
  getReportDownloadsCount$(reportFilters:ReportFilter):Observable<any>{
        const headers = new HttpHeaders().set('content-type', 'application/json');
        const body = reportFilters;
        return this.http.post(this.endpoint+"GenerateReportDownloadsCount", body, {
          headers,
          observe: 'response'
        });
  }
  getVarianceReportByDueDates$(reportFilters:ReportFilter):Observable<any>{
        const headers = new HttpHeaders().set('content-type', 'application/json');
        const body = reportFilters;
        return this.http.post(this.endpoint+"GenerateVarianceReportByDueDates", body, {
          headers,
          observe: 'response'
        });
    
  }

  getSubmittedReportCountByPostAndYear$(reportFilters:ReportFilter):Observable<any>{
        const headers = new HttpHeaders().set('content-type', 'application/json');
        const body = reportFilters;
        return this.http.post(this.endpoint+"GenerateSubmittedReportCountByPostAndYear", body, {
          headers,
          observe: 'response'
        });
    
  }  
 
}



// WEBPACK FOOTER //
// ./src/app/services/analytics.service.ts